import React, { useEffect, useState } from "react";
import { GameTypeSelector, GameTypeMultiSelector } from "./components/Selector";

export default function GameTypeCriteria(props){

    const [seasons, setSeasons] = useState([]);

    useEffect(() => {
        const today = new Date();
        const currentYear = today.getFullYear();
        let arr = [];

        for (let i = 2019; i<= currentYear ; i++){
            arr.push({ value: i, dataLang: i, label: i });
        }

        setSeasons(arr);
    }, []);

    // const seasons = [
    //     { value: "2019", dataLang: "2019", label: "2019" },
    //     { value: "2020", dataLang: "2020", label: "2020" },
    //     { value: "2021", dataLang: "2021", label: "2021" },
    //     { value: "2022", dataLang: "2022", label: "2022" },
    //     { value: "2023", dataLang: "2023", label: "2023" },
    //     { value: "2024", dataLang: "2024", label: "2024" },
    // ]

    const gameTypes = [
        { value: "4201", engName: "regularSeason", label: "패넌트레이스" },
        { value: "4206", engName: "futuresSeason", label: "퓨쳐스" },
        { value: "4212", engName: "reserveSquad", label: "육성군" },
        { value: "4210", engName: "postSeason", label: "포스트시즌" },
        { value: "4208", engName: "majorScrimmage", label: "1군_연습경기" },
        { value: "4213", engName: "futuresScrimmage", label: "2군_연습경기" },
        { value: "4207", engName: "ExhibitionLeague", label: "시범경기" },
        { value: "4214", engName: "fallEduLeague", label: "교육리그" },
    ]

    const playerType = [
        { value: "batter", dataLang: "hitter", label: "타자" },
        { value: "pitcher", dataLang: "pitcher", label: "투수" },
    ]

    return(
        <>
            <div className="row">
                <div className="col-6">
                    <GameTypeSelector
                        title={"시즌"}
                        id={"seasons"}
                        name={"seasons"}
                        value={props.criteria.seasons}
                        options={seasons}
                        setValue={props.changeHandler}
                        dataLang={"season"}
                        useLang={props.useLang}
                    />
                </div>
                <div className="col-6">
                    <GameTypeMultiSelector
                        title={"경기유형"}
                        id={"gameTypes"}
                        name={"gameTypes"}
                        value={props.criteria.gameTypes}
                        options={gameTypes}
                        setValue={props.changeGameTypeHandler}
                        placeHolder={props.useLang == 'en' ? "Select Game Type" : "경기 유형 선택"}
                        dataLang={"gameType"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
            <div className="row" style={{marginTop:"5px"}}>
                <div className="col-6">
                    <GameTypeSelector
                        title={"선수유형"}
                        id={"position"}
                        name={"position"}
                        value={props.criteria.position}
                        options={playerType}
                        setValue={props.changeHandler}
                        dataLang={"playerType"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
        </>
    )
}